import './emptyStateWithAction.less'
import SvgEmptyStateWithAction from '../../assets/inlineSvg/empty-state-with-action.svg'
import { Button, Typography } from '@lightbeamai/design-system'
import React from 'react'
import { Plus } from 'phosphor-react'

interface Props {
  title: string
  info?: React.ReactNode
  actionButtonText: string
  icon?: React.ReactNode
  onClick?: () => void
}

export const EmptyStateWithAction = (props: Props) => {
  const { title, actionButtonText, icon, info, onClick } = props
  return (
    <div className="empty-state-with-action">
      {info && <div className="empty-state-with-action-info">{info}</div>}
      <SvgEmptyStateWithAction />
      <Typography type="medium" className="empty-state-with-action-title">
        {title}
      </Typography>
      {onClick && (
        <Button variant="primary" onClick={onClick} icon={icon ?? <Plus />}>
          {actionButtonText}
        </Button>
      )}
    </div>
  )
}
